import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useState } from "react";

export default function KeywordBox({
    callback,
    initialValue,
    label,
    placeholder,
    fullWidth,
    sx,
    variant = "standard",
    size,
}) {
    const [keyword, setKeyword] = useState(initialValue ?? "");

    useEffect(() => {
        setKeyword(initialValue ?? "");
    }, [initialValue]);

    // Create debounced version of the callback
    const debouncedCallback = useCallback(
        debounce((value) => {
            callback(value);
        }, 300), // 300ms debounce delay
        [callback]
    );

    useEffect(
        () => () => {
            debouncedCallback.cancel();
        },
        [debouncedCallback]
    );

    const handleChange = (e) => {
        const value = e.target.value;
        setKeyword(value);
        debouncedCallback(value);
    };

    const handleClick = () => {
        callback(keyword);
    };

    const handleClear = (e) => {
        e.stopPropagation();
        debouncedCallback.cancel();
        setKeyword("");
        callback("");
    };

    const showClear = String(keyword ?? "").length > 0;

    return (
        <TextField
            id="txtKeyword"
            value={keyword}
            label={label}
            placeholder={placeholder}
            fullWidth={Boolean(fullWidth)}
            variant={variant}
            size={size}
            sx={sx}
            slotProps={{
                input: {
                    startAdornment: (
                        <InputAdornment position="start" onClick={() => handleClick()} style={{ cursor: "pointer" }}>
                            <SearchIcon />
                        </InputAdornment>
                    ),
                    endAdornment: showClear ? (
                        <InputAdornment position="end" sx={{ mr: -0.5 }}>
                            <IconButton
                                type="button"
                                size="small"
                                edge="end"
                                aria-label="Clear keyword"
                                onClick={handleClear}
                            >
                                <ClearIcon fontSize="small" />
                            </IconButton>
                        </InputAdornment>
                    ) : null,
                },
            }}
            variant="standard"
            onChange={handleChange}
        />
    );
}
